var Recharge_Select = {
    listening : true,
    init:function(){

        Recharge_Select.update_reduced_price();
/*
        $("#recharge--price .reduced-price").on('DOMSubtreeModified', function(){
            if(Recharge_Select.listening == true) {
                setTimeout(function(){
                    Recharge_Select.update_reduced_price();
                }, 10);
            }
        });
*/
        $(".recharge--selector .zone-click").on("click touchend", function(e){
            if(e.type == "touchend"){
                $(this).off("click");
            }
            e.stopPropagation();
            e.preventDefault();

            if($(this).parent().hasClass("selected")){
                $(".recharge--selector[type='classic']").addClass("selected");
                $(".recharge--selector[type='subscription']").removeClass("selected");

                $(".recharge--selector[type='classic']").trigger("click");
            }else{
                $(".recharge--selector[type='classic']").removeClass("selected");
                $(".recharge--selector[type='subscription']").addClass("selected");

                $(".recharge--selector[type='subscription']").trigger("click");
            }
        });
    },
    update_reduced_price:function(){
        console.log("   ******** UPDATE REDUCED PRICE ***********  ");
        Recharge_Select.listening = false;
        console.log("HTML : " + $("#recharge--price").html());
        if($(".recharge--selector[type='subscription']").find(".reduced-price").html() != undefined){
            var _reduced_price = parseFloat($(".recharge--selector[type='subscription']").find(".reduced-price").html().split(",").join("."));
        }
        if($(".recharge--selector[type='subscription']").find(".recharge--price").html() != undefined){
            var _reduced_price = parseFloat($(".recharge--selector[type='subscription']").find(".recharge--price").html().split(",").join("."));
        }

        console.log("REDUCED PRICE : " + _reduced_price);
        var _original_price = Math.round(((_reduced_price * 100)/90)*100)/100;

        var _decimal = "";

        if(_original_price%1 != 0){
            if((_original_price*10) % 1 == 0){
                _decimal = "0";
            }
        }

        console.log("CHANGE ORIGINAL PRICE 1 : " + _original_price +" // " + _decimal);
        $(".recharge--selector[type='subscription']").find(".original-price").html(_original_price +""+ _decimal +"€");

        setTimeout(function(){
            Recharge_Select.listening = true;
        }, 40);
    }
}
$(window).on("load", function(){
    if($(".akrolab-template #recharge__select").length){
        Recharge_Select.init();
    }
})